import newCompBtn from '../../images/docs/new-comp-edit.png';
import compEdit from '../../images/docs/comp-list-edit.png';

export const meta = {
  slug: 'firme',
  title: 'Firme',
  description: 'Gestionarea firmelor în platformă, util în special pentru declaranții terți.',
  icon: 'building',
  order: 7,
  related: ['machete', 'generare-intrastat'],
};

export const images = { newCompBtn, compEdit };

export const content = `
## Firme

Pentru a verifica orice informație legată de firme trebuie să fiți autentificat. Acest capitol poate fi util declaranților terți.

### 1. Creare firme

Firmele se pot vizualiza în meniul "Firme". Declaranții terți vor putea gestiona firmele cliente în această secțiune. Datele firmelor sunt utilizate la generarea declarațiilor Intrastat și la asignarea machetelor. Pentru ceilalți utilizatori în acest meniu vor putea să observe doar firma lor.

::image[newCompBtn]{alt="Butonul firmă nouă"}

Pentru a crea o firmă nouă va trebui dat click pe butonul "Firmă nouă". Acesta va dezvălui un formular simplu în care trebuie introduse date legate de firmă:

- Denumire
- CIF
- Oraș (se alege din listă)

Odată ce datele au fost introduse se poate salva firma apăsând butonul verde "Salvează" din josul formularului. Alternativ se poate anula acțiunea de adăugare a firmei prin apăsarea butonului "Anulează" din josul formularului. Valoarea "CIF" va fi apoi validată. Dacă valoarea nu este validă firma nu poate fi adăugată în listă.

### 2. Vizualizează, editează și șterge firme

Firmele pot fi vizualizate în lista din meniul "Firme".

::image[compEdit]{alt="Vizualizare firme"}

În această listă putem observa denumirea firmei <span class="dot">1</span>, CIF-ul firmei <span class="dot">2</span>, locația firmei <span class="dot">3</span>, acțiunile ce pot fi efectuate asupra firmei respective <span class="dot">4</span>, <span class="dot">5</span> și numărul de firme disponibil conform abonamentului activ <span class="dot">6</span>.

Prima firmă din listă (cea cu Nr. 1) va fi mereu firma utilizatorului.

Pentru a edita o firmă din listă trebuie dat click pe butonul verde <span class="dot">4</span> din lista de acțiuni a firmei selectate. De acolo se va afișa formularul de editare al informațiilor. Pentru mai multe detalii legate de acesta puteți vizualiza capitolul anterior.

Pentru a șterge o firmă trebuie dat click pe butonul roșu "X" <span class="dot">5</span> din lista de acțiuni a firmei respective.
`;
